export { default } from './Success3dIllustration';
